export enum MasterEventPrefix {
    Live = "live-",
    PreLive = "prelive-"
}